import React, { Component } from 'react';
import Editor, { createEditorStateWithText } from '@draft-js-plugins/editor';
import createHashtagPlugin from '@draft-js-plugins/hashtag';
import { eventBus } from '@/utils/common.utils';
import debounce from 'lodash/debounce';
import createMentionPlugin from '@draft-js-plugins/mention';
import { filterMentions } from './mentions.vue';
import { EditorState, Modifier, SelectionState } from 'draft-js';

const hashtagPlugin = createHashtagPlugin({});
const mentionPlugin = createMentionPlugin({
    mentionPrefix: '@',
});
const { MentionSuggestions } = mentionPlugin;

const plugins = [hashtagPlugin, mentionPlugin];

export default class CustomHashtagEditor extends Component {

    state = {
        editorState: createEditorStateWithText(this.props.value),
        suggestions: [],
        users: [],
        open: false,
        searchTerm: '',
        firstTimeCall: true,
    };
    constructor(props) {
        super(props);
        this.debouncedFilterMentions = debounce(this.filterMentions, 3000);
        eventBus.$on("updateEditorText" + this.props.editorId, (text) => {
            this.setState({
                editorState: createEditorStateWithText(text),
            });
        });
        eventBus.$on("insertTextAtCursor" + this.props.editorId, (text) => {
            this.insertTextAtCursor(text);
        });
    }

    componentDidMount() {
        eventBus.$on("mentionDataLoading", this.handleMentionDataLoading);
    }

    componentWillUnmount() {
        eventBus.$off("mentionDataLoading", this.handleMentionDataLoading);
        eventBus.$off("updateEditorText" + this.props.editorId);
        eventBus.$off("insertTextAtCursor" + this.props.editorId);
    }

    insertTextAtCursor = (text) => {
        const { editorState } = this.state;
        const contentState = editorState.getCurrentContent();
        const selection = editorState.getSelection();
        
        const newContentState = Modifier.insertText(
            contentState,
            selection,
            text
        );

        const newEditorState = EditorState.push(
            editorState,
            newContentState,
            'insert-characters'
        );

        this.onChange(newEditorState);
    }

    getEditorText = () => {
        return this.state.editorState.getCurrentContent().getPlainText();
    }

    handleMentionDataLoading = (isLoading) => {
        eventBus.$emit("mentionDataLoadingEditor", isLoading);
    }

    onChange = (editorState) => {
        let val = editorState.getCurrentContent().getPlainText();
        this.props.onInput(val)
        this.setState({
            editorState,
        });
    };

    onOpenChange = (isOpen) => {
        this.setState({
            open: true,
        });
    };

    onSearchChange = async ({ value }) => {
        eventBus.$emit("mentionsSearchText", value);
        if(value && value.length > 0) {
            eventBus.$emit("mentionDataLoading", true);
        } else if(value.length == 0) {
            eventBus.$emit("mentionDataLoading", false);
        }
        this.setState({ searchTerm: value });
        this.debouncedFilterMentions();
    };

    filterMentions = async () => {
        try {
            if(this.props.editorId == 'instagram' || this.props.editorId == 'twitter') {
                if(this.state.searchTerm) {
                    const MentionedUsers = await filterMentions(this.state.searchTerm, this.props.uid, this.props.wid, this.props.editorId);
                    if(MentionedUsers) {
                        this.setState({
                            suggestions: MentionedUsers,
                        });
                    }
                }
                else if(!this.state.searchTerm || this.state.searchTerm == 0) {
                    this.setState({
                        suggestions: [],
                    });
                }
            }

        } catch (error) {
            console.error('Error filtering mentions:', error);
        }
    };

    focus = () => {
        this.editor.focus();
    };

    render() {
        return (
            <div onClick={this.focus}>
                <Editor
                    editorState={this.state.editorState}
                    onChange={this.onChange}
                    plugins={plugins}
                    ref={(element) => {
                        this.editor = element;
                    }}
                />
                <MentionSuggestions
                    open={this.state.open}
                    onOpenChange={this.onOpenChange}
                    onSearchChange={this.onSearchChange}
                    suggestions={this.state.suggestions}
                    onAddMention={(mention) => {
            this.setState({
                suggestions: []
            })
                        console.log("Mention added:", mention);
                    }}
                />
            </div>
        );
    }
}